import { PropsWithChildren } from "react";

import {
    SiteSelectorContextProvider,
    SiteSelectorContextProviderProps
} from "@/components/site-selector-modal/index.ts";

export interface OptionalSiteSelectorContextProviderProps
    extends PropsWithChildren {
    siteSelectorProductKey?: string;
}

export const OptionalSiteSelectorContextProvider = (
    props: OptionalSiteSelectorContextProviderProps
) => {
    const { siteSelectorProductKey, children } = props;
    if (!siteSelectorProductKey) {
        return <>{children}</>;
    }

    return (
        <SiteSelectorContextProvider
            productKey={
                siteSelectorProductKey as SiteSelectorContextProviderProps["productKey"]
            }
            analyticsPrefix={siteSelectorProductKey}
        >
            {children}
        </SiteSelectorContextProvider>
    );
};
